module.exports = __webpack_public_path__ + "static/img/channelH.a9f5e8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/channelH.png
// module id = RNY0
// module chunks = 83